import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  flexContainer: {
    justifyContent: ({ justifyContent }) => justifyContent,
  },
}));
